/* eslint-disable react-hooks/set-state-in-effect */
import { useEffect, useState } from "react";
import { Info, Lightbulb, X } from "@phosphor-icons/react";
import api from "@/lib/api";

const cache = {};

export default function PageGuide({ pageId }) {
  const [guide, setGuide] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!pageId) return;
    if (cache[pageId]) {
      setGuide(cache[pageId]);
      return;
    }

    api.get(`/page-guide/${pageId}`).then((r) => {
      cache[pageId] = r.data;
      setGuide(r.data);
    }).catch(() => {});
  }, [pageId]);

  if (!guide) return null;

  return (
    <>
      <button
        data-testid={`page-guide-${pageId}`}
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1.5 text-xs theme-ink-muted hover:text-gold transition-colors border theme-border px-2.5 py-1 rounded-sm"
      >
        <Info size={12} weight="fill" /> Quick info
      </button>

      {open && (
        <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setOpen(false)}>
          <div
            className="theme-surface border theme-border max-w-lg w-full p-7 shadow-xl"
            onClick={(e) => e.stopPropagation()}
            data-testid={`page-guide-modal-${pageId}`}
          >
            <div className="flex items-start gap-3">
              <Lightbulb size={22} weight="fill" className="text-gold shrink-0 mt-1" />
              <div className="flex-1">
                <div className="overline">Page guide</div>
                <h3 className="font-serif-display text-2xl theme-ink mt-1">{guide.title}</h3>
                <p className="text-sm theme-ink-muted mt-2 leading-relaxed">{guide.summary}</p>

                <div className="overline mt-5 mb-2">Tips</div>
                <ul className="space-y-2 text-sm theme-ink">
                  {guide.tips.map((t, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <span className="text-gold mt-0.5">•</span>
                      <span className="theme-ink-muted">{t}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <button onClick={() => setOpen(false)} className="theme-ink-dim hover:theme-ink" aria-label="Close">
                <X size={18} />
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
